import React from 'react';

// Gets injected into the Navigator
// Added arbitrary minHeight to ensure that the footer is below the fold
// To prevent a weird UI flash when loading in the module
const LoadingComponent = () => <div style={{ minHeight: '150vh' }} />;

export default LoadingComponent;
